import { ApplicationConfig } from 'src/app/core/config';

export const environment: ApplicationConfig = {
  production: true,
  webServiceUrl: 'https://portal-atlasx.cdg.co.th/ml-search-ws',
  
  //'https://atlasx.cdg.co.th/ml-search-ws'
  //'http://127.0.0.1:5002'
};
